import { Component, ChangeDetectionStrategy } from '@angular/core';

/**
 * The sign-in layout for a page with nothing to fill in: the logo and the route's greeting on the left,
 * and the white card on the right holding a loader. The card stays where the sign-in form's is, so
 * moving between this and a page with controls changes only what is inside it. The pre-boot shell in
 * src/index.html draws the same markup. The layout comes from the global `.main` and `.page-loader-*`
 * rules in styles.scss.
 */
@Component({
    selector: 'app-page-loader',
    templateUrl: './page-loader.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PageLoaderComponent {
}
